import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL ="https://api.machinery.fcpo.ma/api"

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/me`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/reset-password`


// Server should return AuthModel
export function login(email: string, password: string) {
  console.log(LOGIN_URL);
  
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(oldpassword: string,newpassword:string) {
  return axios.post(REQUEST_PASSWORD_URL, {
    oldpassword,newpassword
  })
}

export function getUserByToken(token: string) {
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}
